<div>
  <div class="modal-header">
    <h4 class="modal-title">
      <label>{{ 'MODULE.DATA_APPLICATIONS.TOP_BAR.SETTING_LABEL' | translate }}</label>
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <label>{{ 'MODULE.DATA_APPLICATIONS.TOP_BAR.LABEL' | translate }}</label>
      <div class="col-md-12">
        <mat-radio-group
          aria-labelledby="radio-group-label"
          class="radio-group mt-0"
          [(ngModel)]="label"
          required
        >
          <mat-radio-button class="radio-button" value="default">
            {{ 'MODULE.DATA_APPLICATIONS.TOP_BAR.DEFAULT' | translate }}
          </mat-radio-button>

          <mat-radio-button class="radio-button" value="no_label">
            {{ 'MODULE.DATA_APPLICATIONS.TOP_BAR.NO_LABEL' | translate }}
          </mat-radio-button>

          <mat-radio-button class="radio-button" value="with_label">
            {{ 'MODULE.DATA_APPLICATIONS.TOP_BAR.WITH_LABEL' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div class="row">
        <label>{{ 'MODULE.DATA_APPLICATIONS.TOP_BAR.LEGEND' | translate }}</label>
        <div class="col-md-12">
          <mat-radio-group
            aria-labelledby="radio-group-label"
            class="radio-group mt-0"
            [(ngModel)]="legend"
            required
          >
            <mat-radio-button class="radio-button" value="default">
                {{ 'MODULE.DATA_APPLICATIONS.TOP_BAR.DEFAULT' | translate }}
            </mat-radio-button>

            <mat-radio-button class="radio-button" value="no_legend">
                {{ 'MODULE.DATA_APPLICATIONS.TOP_BAR.NO_LEGEND' | translate }}
            </mat-radio-button>

            <mat-radio-button class="radio-button" value="with_legend">
                {{ 'MODULE.DATA_APPLICATIONS.TOP_BAR.WITH_LEGEND' | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
    </div>
  </div>
  <div class="modal-footer">
    <button id="btn-danger" class="btn btn-simple btn-outline btn-sm close" type="button" (click)="resetSettings()">
      {{ 'MODULE.DATA_APPLICATIONS.TOP_BAR.RESET' | translate }}
    </button>
    <button class="btn btn-info btn-simple btn-sm f-12" type="button" (click)="onYesClick()">
      {{ 'MODULE.DATA_APPLICATIONS.TOP_BAR.APPLY' | translate }}
    </button>
  </div>
</div>
